<template>
  <div class="footerWrapper wd-w-full" :class="{ 'wd-flex wd-mx-24 wd-justify-between wd-items-center': isUpMedium }">
    <div v-if="!shouldTermsHide" class="wd-flex wd-items-center" :class="{ 'wd-justify-center wd-mb-4': !isUpMedium }">
      <a class="termLink" target="_blank" :href="`${funbookV2PathPrefix}/terms`">{{ $t('term_cusomer') }}</a>
      <span class="wd-mx-1">|</span>
      <a class="termLink" target="_blank" :href="`${funbookV2PathPrefix}/terms/privacy`">{{ $t('term_privacy') }}</a>
    </div>
    <!-- add empty div tag for positioning -->
    <div v-else />

    <div :class="{ 'wd-flex wd-items-center': isUpMedium }">
      <p class="mb-0" :class="isUpMedium ? 'wd-mr-6' : 'wd-mr-0 copyright'">&copy; {{ thisYear }} Zoek. All rights reserved.</p>
      <div class="wd-flex wd-relative" :class="{ 'wd-justify-center wd-items-center': !isUpMedium }">
        <span :class="isUpMedium ? 'wd-mr-2' : 'wd-mr-0'">Powered by</span>
        <a v-if="currentLocale.code === 'zh-tw'" :class="isUpMedium ? 'logoLink' : 'wd-py-1 wd-px-2'" target="_blank" :href="partnerLink">
          <v-img class="logo" cover width="72" src="@/assets/images/logo/logo.svg?url" />
        </a>
        <span v-else :class="isUpMedium ? 'logoLink' : 'wd-py-1 wd-px-2'">
          <v-img class="logo" cover width="72" src="@/assets/images/logo/logo.svg?url" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import tools from '@/mixin/tools'
import { useFunBookV2 } from '@/composition/useFunbookV2'
import { usePartnerLinks } from '@/composition/useConst'

export default defineComponent({
  name: 'FunBookV2Footer',
  components: {},
  mixins: [tools],
  props: {
    isUpMedium: { type: Boolean, default: false },
    thisYear: { type: Number, default: 2022 },
    currentLocale: { type: Object, default: () => ({}) },
    shouldTermsHide: { type: Boolean, default: false },
  },
  setup() {
    const nuxtApp = useNuxtApp()
    const { branchId } = useFunBookV2()
    const funbookV2PathPrefix = computed(() => nuxtApp.$localePath(`/funbook/${branchId.value}`))
    const { partnerLink } = usePartnerLinks()

    return {
      funbookV2PathPrefix,
      partnerLink,
    }
  },
})
</script>

<style lang="scss" scoped>
.footerWrapper {
  font-size: 13px;
  line-height: 20px;
}
.termLink {
  display: inline-block;
  padding: 2px 12px;
  /* To override origin a tag style */
  color: $white !important;
}
.logoLink {
  position: relative;
  top: -1px;
}
.copyright {
  text-align: center;
}
</style>
